import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FilterValueType } from '../../filtered-search.component';

@Component({
  selector: 'date-filter',
  styleUrl: '../filtered-search-option.component.scss',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, ReactiveFormsModule, L10nTranslatePipe],
  template: `
    <mat-form-field
      class="filter-form"
      appearance="outline"
      (click)="$event.stopPropagation(); $event.preventDefault()"
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
      [attr.data-test]="'filter-date'"
    >
      <mat-label>
        {{ 'Filter.Value' | translate: locale.language }}
      </mat-label>
      <input [attr.data-test]="'filter-date-input'" matInput [formControl]="control" [matDatepicker]="picker" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);

  @Input() control: FormControl<FilterValueType>;
}
